import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
// Removed NewsCard import
import PageBanner from "../components/PageBanner";
import { getNewsData } from "../api/dataSource";

export default function NewsList() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const focusId = params.get("focus");

  const [newsData, setNewsData] = useState([]);
  // Create refs for each news card
  const refs = useRef({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await getNewsData();
      setNewsData(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (focusId && refs.current[focusId]) {
      refs.current[focusId].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [focusId, newsData]);

  return (
    <>
      <PageBanner
        title="Latest News"
        subtitle="Official updates from Ranipet District Chess Academy"
        image="/images/chess.png"
      />

      <div className="max-w-6xl mx-auto px-4 py-12 space-y-10">
        {newsData && newsData.length > 0 ? (
          newsData.map((item) => (
            <div
              key={item.id}
              ref={(el) => (refs.current[item.id] = el)}
            >
              <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all overflow-hidden border-l-4 border-blue-600">
                <div className="flex flex-col md:flex-row">
                  <div className="w-full md:w-[260px] md:h-[180px] h-[200px]">
                    <img
                      src={item.image || `/images/news${item.id}.jpg`}
                      alt={item.title}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.src = `/images/news${item.id}.jpg`;
                      }}
                    />
                  </div>
                  <div className="flex-1 p-6">
                    <h3 className="text-lg md:text-xl font-semibold text-blue-700 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
                <div className="border-t px-6 py-4 flex items-center justify-between bg-gray-50">
                  <span className="text-sm text-gray-500">
                    {item.date || "RDCA Official"}
                  </span>
                  {item.link && (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 text-blue-600 font-semibold hover:gap-3 transition-all"
                    >
                      Read full update
                      <span className="text-lg">→</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">Loading news...</p>
          </div>
        )}
      </div>
    </>
  );
}